/* eslint-disable react/prop-types */
import classes from './Cards.module.scss';
import {Link} from 'react-router-dom' ;
//

const Card = ({title , overview , secImg,id})=>{
    return (
        <div className={classes["room__card"]}>
            <div className={classes["room__card__image"]}>
                <img src={secImg} alt="product" loading="lazy"/>
            </div>
            <div className={classes["room__card__details"]}>
                <h4>{title}</h4>
                <p>
                    {overview}
                </p>
                <button className={classes["product___btn"]} >
                    <Link to={`/products/${id}`}>Learn More</Link>
                </button>
            </div>
        </div>
    )
}

function Cards({data,src}) {
    return (
        <section className={`${classes["room__container"]} ${classes["section__container"]}`}>

            <h2 className={classes["section__header"]}>{
                data?.length > 0 ? `${data?.length} results for "${src.slice(0,25)}..."`:
                `No results found for "${src.slice(0,25)}..."`
            }</h2>
    {/* ================================================================= */}
            <div className={classes["room__grid"]}>
                {data.map((ele,i)=>{
                    return((<Card  key={i} id={ele.id} title={ele.productTitle} secImg={ele.img_1} overview={ele.sub_title_1}/>))
                })}
            </div>
        </section>
    )
}

export default Cards